// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface FinancialEffectsSelectionState {
  // Currently no selection state needed; extend as needed
}

function serializeSelectionState(_state: FinancialEffectsSelectionState) {
  return undefined;
}

function unserializeSelectionState(_value: string | undefined): FinancialEffectsSelectionState {
  return {};
}

function isImpactHighlighted() {
  return false;
}

export const financialEffectsLensSelectionState = {
  serializeSelectionState,
  // TODO should this be removed?
  unserializeSelectionState,
  isImpactHighlighted,
};
